export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_36-638b7335cccdde71f96d45abf577954a.jpg";